import {Component, Inject} from '@angular/core';
import {Authentication, AUTHENTICATION} from '@infrastructure/http/authentication/authentication';
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({
  selector: 'app-grid-owner-label',
  templateUrl: './grid-owner-label.component.html',
  styleUrls: ['./grid-owner-label.component.scss']
})
export class GridOwnerLabelComponent implements ICellRendererAngularComp {
  public fromVandewiele: boolean;

  public constructor(@Inject(AUTHENTICATION) private authentication: Authentication) {}

  public agInit(params: any): void {
    this.fromVandewiele = params.data.fromVandewiele ?? false;
  }

  public refresh(params: any): boolean {
    return false;
  }

  public getLabelForOwner(): string {
    if (this.fromVandewiele) {
      return 'Vandewiele';
    } else {
      return this.authentication.getCurrentSubscription().name;
    }
  }
}
